var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("checked-tab", {
        attrs: { configObj: _vm.defaultConfig, configNme: "setUp" },
        on: { getConfig: _vm.getConfig },
      }),
      _vm.actived === 0
        ? _c(
            "div",
            [
              _c("c-title", {
                attrs: { configObj: _vm.defaultConfig, configNme: "titleCent" },
              }),
              this.$route.query.type !== 2
                ? _c("div", { staticClass: "c_row-item" }, [
                    _c("div", { staticClass: "label" }, [_vm._v("模板名称")]),
                    _c(
                      "div",
                      { staticClass: "slider-box" },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "small",
                            placeholder: "选填不超过15个字",
                            maxlength: "15",
                          },
                          on: { change: _vm.changName },
                          model: {
                            value: _vm.name,
                            callback: function ($$v) {
                              _vm.name = $$v
                            },
                            expression: "name",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "c_row-item" }, [
                _c("div", { staticClass: "label" }, [_vm._v("页面标题")]),
                _c(
                  "div",
                  { staticClass: "slider-box" },
                  [
                    _c("el-input", {
                      attrs: {
                        size: "small",
                        placeholder: "选填不超过30个字",
                        maxlength: "30",
                      },
                      on: { change: _vm.changVal },
                      model: {
                        value: _vm.title,
                        callback: function ($$v) {
                          _vm.title = $$v
                        },
                        expression: "title",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "mt20" },
                [
                  _c("txt-tab", {
                    attrs: {
                      configObj: _vm.defaultConfig,
                      configNme: "textPosition",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.actived === 1
        ? _c(
            "div",
            [
              _c("c-title", {
                attrs: {
                  configObj: _vm.defaultConfig,
                  configNme: "titleColor",
                },
              }),
              _c("div", { staticClass: "c_row-item" }, [
                _c("div", { staticClass: "label" }, [_vm._v("背景设置")]),
                _c(
                  "div",
                  { staticClass: "slider-box acea-row row-middle" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.handleColorRadio()
                          },
                        },
                        model: {
                          value: _vm.colorRadio,
                          callback: function ($$v) {
                            _vm.colorRadio = $$v
                          },
                          expression: "colorRadio",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: "1" } }, [
                          _vm._v("背景色"),
                        ]),
                        _c("el-radio", { attrs: { label: "2" } }, [
                          _vm._v("背景图"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm.colorRadio === "1"
                ? _c("div", { staticClass: "c_row-item" }, [
                    _c("div", { staticClass: "label" }, [_vm._v("背景颜色")]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "slider-box acea-row row-between row-middle",
                      },
                      [
                        _c("el-color-picker", {
                          on: {
                            change: function ($event) {
                              return _vm.colorPickerTap(_vm.colorPicker)
                            },
                          },
                          model: {
                            value: _vm.colorPicker,
                            callback: function ($$v) {
                              _vm.colorPicker = $$v
                            },
                            expression: "colorPicker",
                          },
                        }),
                        _c("el-input", {
                          staticClass: "widthIpt",
                          attrs: { size: "small" },
                          model: {
                            value: _vm.colorPicker,
                            callback: function ($$v) {
                              _vm.colorPicker = $$v
                            },
                            expression: "colorPicker",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "resetBtn",
                            on: { click: _vm.resetBgB },
                          },
                          [_vm._v("重置")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.colorRadio === "2"
                ? _c("div", { staticClass: "c_row-item acea-row row-top" }, [
                    _c("div", { staticClass: "label" }, [_vm._v("背景图片")]),
                    _c("div", { staticClass: "slider-box" }, [
                      _c(
                        "div",
                        { staticClass: "acea-row row-between row-middle" },
                        [
                          _vm._m(0),
                          _c(
                            "div",
                            {
                              staticClass: "boxs",
                              on: { click: _vm.modalPicTap },
                            },
                            [
                              _vm.bgPicUrl
                                ? _c("img", {
                                    attrs: { src: _vm.bgPicUrl, alt: "" },
                                  })
                                : _c("div", { staticClass: "upload-box" }, [
                                    _c("i", {
                                      staticClass: "iconfont icon-tianjia1",
                                    }),
                                  ]),
                              _vm.bgPicUrl
                                ? _c("div", { staticClass: "replace" }, [
                                    _vm._v("更换图片"),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.colorRadio === "2"
                ? _c("div", { staticClass: "c_row-item" }, [
                    _c("div", { staticClass: "label" }, [_vm._v("填充方式")]),
                    _c(
                      "div",
                      { staticClass: "slider-box acea-row row-middle" },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { type: "button" },
                            on: { change: _vm.radioTap },
                            model: {
                              value: _vm.tabVal,
                              callback: function ($$v) {
                                _vm.tabVal = $$v
                              },
                              expression: "tabVal",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "0" } }, [
                              _vm._v("拉伸"),
                            ]),
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("缩放"),
                            ]),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v("填充"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "c_row-item" }, [
                _c("div", { staticClass: "label" }, [_vm._v("顶部颜色")]),
                _c(
                  "div",
                  { staticClass: "slider-box acea-row row-between row-middle" },
                  [
                    _c("el-color-picker", {
                      on: {
                        change: function ($event) {
                          return _vm.titleBgPickerTap(_vm.titleBgColor)
                        },
                      },
                      model: {
                        value: _vm.titleBgColor,
                        callback: function ($$v) {
                          _vm.titleBgColor = $$v
                        },
                        expression: "titleBgColor",
                      },
                    }),
                    _c("el-input", {
                      staticClass: "widthIpt",
                      attrs: { size: "small" },
                      model: {
                        value: _vm.titleBgColor,
                        callback: function ($$v) {
                          _vm.titleBgColor = $$v
                        },
                        expression: "titleBgColor",
                      },
                    }),
                    _c(
                      "span",
                      { staticClass: "resetBtn", on: { click: _vm.resetBgA } },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "c_row-item" }, [
                _c("div", { staticClass: "label" }, [_vm._v("标题颜色")]),
                _c(
                  "div",
                  { staticClass: "slider-box acea-row row-between row-middle" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.handleChangeTitle(_vm.titleColor)
                          },
                        },
                        model: {
                          value: _vm.titleColor,
                          callback: function ($$v) {
                            _vm.titleColor = $$v
                          },
                          expression: "titleColor",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: "#ffffff" } }, [
                          _vm._v("白色"),
                        ]),
                        _c("el-radio", { attrs: { label: "#000000" } }, [
                          _vm._v("黑色"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c("linkaddress", { ref: "linkaddres", on: { linkUrl: _vm.linkUrl } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", [_vm._v("上传图片")]),
      _c("div", [_vm._v("建议：宽度750px")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }